<form [formGroup]="form" (ngSubmit)="fieldFormSubmit()" class="ot-form-multi-line-text" [ngClass]="wrapperClass()"
  [style.maxWidth.rem]="maxWidth" [style.minWidth.rem]="minWidth">
  <file360-field-label [elementId]="elementId" [label]="label" [hoverTip]="hoverTip"
    [showRequiredIndication]="showRequiredIndication" [readOnly]="readOnly"></file360-field-label>

  <!-- 
      For read-only select, use read-only text field. 
      Disabled state overrides read-only state.
    -->

  <div *ngIf="readOnly && !field.disabled && !isValueEmpty(field.value)" class='ot-read-only-container' tabindex="0"
    [style.maxHeight.rem]="maxHeight">
    {{field.value}}
  </div>

  <div *ngIf="readOnly && !field.disabled && isValueEmpty(field.value)" class='ot-empty-read-only-container'
    tabindex="0" [style.maxHeight.rem]="maxHeight">
    No value
  </div>

  <textarea *ngIf="!readOnly || field.disabled" [id]="elementId" (focus)="onFocus()" (blur)="onBlur()"
    (input)="valueChanged(field.value)" [placeholder]="placeholder" formControlName="field" cdkTextareaAutosize
    #autosize="cdkTextareaAutosize" [cdkAutosizeMinRows]="minRows" [cdkAutosizeMaxRows]="maxRows"></textarea>

  <file360-field-error #error [elementId]="elementId"></file360-field-error>
  <!-- Hidden submit button needed for ngSubmit-->
  <button type="submit" style="display:none"></button>
</form>